import Store from ".";
import MetadataStore from "./metadataStore";
import GridLayoutStore from "./gridLayoutStore";
import SynchronizationStore from "./synchronizationStore";
import SeriesListStore from "./seriesListStore";
import MeasureToolStore from "./measureToolStore";
import HotkeyStore from "./hotkeyStore";
import ToolbarStore from "./toolbarStore";
import DialogStore from "./dialogStore";
import ElementViewConfigStore from "./ElementViewConfigStore";
import LicenseStore from "./licenseStore";
import AuthStore from "./authStore";

/**
 * @class RootStore
 * @description 여럿 Store들을 연결
 */
export default class RootStore {
  metadataStore: MetadataStore; /// Study 목록 정보 저장 Store
  gridLayoutStore: GridLayoutStore;
  synchronizationStore: SynchronizationStore;
  seriesListStore: SeriesListStore;
  measureToolStore: MeasureToolStore;
  hotkeyStore: HotkeyStore;
  toolbarStore: ToolbarStore;
  dialogStore: DialogStore;
  elementViewConfigStore: ElementViewConfigStore;
  licenseStore: LicenseStore;
  authStore: AuthStore;

  constructor() {
    this.metadataStore = new Store.MetadataStore(this); /// Study 목록 정보를 저장하는 Store 연결
    this.gridLayoutStore = new Store.GridLayoutStore(this);
    this.synchronizationStore = new Store.SynchronizationStore(this);
    this.seriesListStore = new Store.SeriesListStore(this);
    this.measureToolStore = new Store.MeasureToolStore(this);
    this.hotkeyStore = new Store.HotkeyStore(this);
    this.toolbarStore = new Store.ToolbarStore(this);
    this.dialogStore = new Store.DialogStore(this);
    this.elementViewConfigStore = new Store.ElementViewConfigStore(this);
    this.licenseStore = new Store.LicenseStore(this);
    this.authStore = new Store.AuthStore(this);
  }
}
